import { AppDatatableChangeEvent } from "./change-event.model";
import { AppDatatableActionEvent } from "./action-event.model";

export class AppDatatableNavigationOptions {

    public sortBy: string;
    public sortDirection: string;
    public searchString: string;
    public selectedRows: Array<any>;
    public isLoading: boolean;
    public hasTreeColumn: boolean;
    public changeEvent: AppDatatableChangeEvent;
    public changeAction: AppDatatableActionEvent;
    public queryOptions: Map<string, string>;

    constructor() {
        this.hasTreeColumn = false;
        this.selectedRows = [];
        this.queryOptions = new Map<string, string>();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/datatable/models/navigation-options.model.ts